import { useParams } from 'react-router-dom';

import UseRestrictionPolicyKo from './ko';
import UseRestrictionPolicyTh from './th';

const UseRestrictionPolicy = () => {
  const { language = 'ko' } = useParams();

  if (language === 'th') return <UseRestrictionPolicyTh />;
  return <UseRestrictionPolicyKo />;
};

export default UseRestrictionPolicy;
